import React from "react";
import { RouteObject } from "react-router-dom";
import withSuspense from "../../components/wrappers/WithSuspense";
const Course = React.lazy(() => import("./"));
const AllCourses = React.lazy(() => import("./pages/AllCourses"));

export const courseRoutes: RouteObject[] = [
  {
    path: "",
    element: withSuspense(AllCourses),
  },
  {
    path: ":courseId",
    element: withSuspense(Course),
  },
];
